import { FieldText } from './FieldText'

export const FieldEmail = ({ name, required, value, label, onChange, readOnly, placeholder, autoComplete = 'email', error }) => {
  return (
    <FieldText
      type={'email'}
      name={name}
      required={required}
      value={value}
      label={label}
      onChange={onChange}
      readOnly={readOnly}
      placeholder={placeholder}
      autoComplete={autoComplete}
      error={error}
    />
  )
}
